<template>
  <button @click="handleClick" :data-status="status">{{ buttonText }}</button>
</template>
<script>
import { __ } from 'bits/intl'
import ajax from 'bits/ajax'

export default {
  props: {
    status: {
      default: 'following',
    },
    targetUserId: Number,
  },
  computed: {
    buttonText: function() {
      if (this.status === 'following') {
        return __('Following')
      } else {
        return __('Follow')
      }
    },
  },
  methods: {
    follow: function() {
      var self
      self = this
      return ajax('/api/user_follows.json', {
        method: 'POST',
        dataType: 'json',
        data: {
          user_id: self.targetUserId,
        },
      })
        .then(function() {
          return (self.status = 'following')
        })
        .catch(function() {
          return alert(__('Oops! Something went wrong. Please try again.'))
        })
    },
    unfollow: function() {
      var self
      self = this
      return ajax('/api/user_follows.json', {
        method: 'DELETE',
        dataType: 'json',
        data: {
          user_id: self.targetUserId,
        },
      })
        .then(function() {
          return (self.status = 'notfollowing')
        })
        .catch(function() {
          return alert(__('Oops! Something went wrong. Please try again.'))
        })
    },
    handleClick: function() {
      if (this.status === 'following') {
        return this.unfollow()
      } else {
        return this.follow()
      }
    },
  },
}
</script>
<style lang="scss" scoped>
@import './../../assets/stylesheets/3/modules/all';

button[data-status='following'] {
  @include inverse-button-color($green-color);
}
</style>
